var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconErrorTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_9832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.21758 2.89491L1.86508 13.4999C1.7341 13.7267 1.6648 13.9839 1.66407 14.2458C1.66334 14.5077 1.73119 14.7653 1.8609 14.9928C1.9906 15.2204 2.17762 15.41 2.40336 15.5428C2.62909 15.6756 2.88568 15.747 3.14758 15.7499L15.8526 15.7499C16.1145 15.747 16.3711 15.6756 16.5968 15.5428C16.8225 15.41 17.0096 15.2204 17.1393 14.9928C17.269 14.7653 17.3368 14.5077 17.3361 14.2458C17.3354 13.9839 17.2661 13.7267 17.1351 13.4999L10.7826 2.89491C10.6489 2.67449 10.4606 2.49225 10.236 2.36577C10.0113 2.2393 9.75788 2.17285 9.50008 2.17285C9.24228 2.17285 8.98883 2.2393 8.76418 2.36577C8.53954 2.49225 8.35128 2.67449 8.21758 2.89491V2.89491Z",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.75V9.75",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.75H9.5075",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_9832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorTriangle);
export default __webpack_public_path__ + "static/media/icon_error_triangle.60782c3033d431a41878d8ebfd769774.svg";
export { ForwardRef as ReactComponent };